import React, { useRef, useEffect } from "react"
import { createContextLogger } from "@/utils/logger/client"

const AlbyQA = props => {
  const { widgetId = "", skuId = "", threadId = "" } = props || {}

  const logger = createContextLogger("pdp:alby-qa")
  const albyElementRef = useRef(null)
  const previousSkuId = useRef(skuId)

  useEffect(() => {
    const callSwitchProduct = async () => {
      if (
        skuId &&
        skuId !== previousSkuId.current &&
        albyElementRef.current?.switchProduct
      ) {
        try {
          await albyElementRef.current.switchProduct(skuId)
          previousSkuId.current = skuId
        } catch (error) {
          logger.error("Failed to switch Alby QA product", {
            error,
            skuId,
            threadId,
            widgetId,
          })
        }
      } else if (skuId !== previousSkuId.current) {
        previousSkuId.current = skuId
      }
    }

    const timer = setTimeout(callSwitchProduct, 100)
    return () => clearTimeout(timer)
  }, [skuId])

  return (
    <div className="alby-qa-container">
      <alby-generative-qa
        ref={albyElementRef}
        widget-id={widgetId}
        product-id={skuId}
        thread-id={threadId}
      />
    </div>
  )
}

export default React.memo(AlbyQA)
